import type { ZodSchema } from 'zod'

import type { CornerStatus, EatPlace, OrderStatus } from './store/types'

export const parseEatPlace = (eat_place: EatPlace, car_number: string | null, table: string | null) =>
  eat_place === 'car'
    ? `к машине (${car_number})`
    : eat_place === 'market_table'
    ? `На рынке к столу ${table}`
    : eat_place === 'market_corner'
    ? 'на подносе'
    : eat_place === 'togo_corner'
    ? 'С собой (на стойке корнера)'
    : eat_place === 'togo_courier'
    ? 'С собой(у раннера)'
    : eat_place === 'togo_market'
    ? 'со стойки HN'
    : eat_place === 'togo_delivery'
    ? 'доставка'
    : eat_place === 'togo_yandex'
    ? 'Яндекс'
    : eat_place === 'togo_yandex_pickup'
    ? 'Яндекс (самовывоз)'
    : eat_place === 'togo_magnit'
    ? 'Магнит'
    : eat_place === 'togo_sber'
    ? 'Купер'
    : eat_place === 'togo_vkusvill'
    ? 'ВкусВилл'
    : eat_place === 'consumer'
    ? `Gremm. стол ${table}`
    : eat_place === 'togo_vkusvill'
    ? 'ВкусВилл'
    : '!'

export const monthList = [
  'январь',
  'февраль',
  'март',
  'апрель',
  'май',
  'июнь',
  'июль',
  'август',
  'сентябрь',
  'октябрь',
  'ноябрь',
  'декабрь',
]

export const getDateString = () => {
  const today = new Date()

  const day = today.getDate()
  const month = today.getMonth()
  const year = today.getFullYear()

  return `${day} ${monthList[month]} ${year}`
}

export const getTimeString = (time: number) => {
  const date = new Date(time * 1000)

  const hours = date.getHours()
  const minutes = `0${date.getMinutes()}`

  return `${hours}:${minutes.substr(-2)}`
}

export const translateToStyleCorner = (status: CornerStatus) =>
  status === 'waiting'
    ? 'не принят'
    : status === 'confirmed'
    ? 'принял'
    : status === 'refused'
    ? 'отклонил'
    : status === 'expects'
    ? 'ожидает'
    : status === 'cooking'
    ? 'готовится'
    : status === 'ready'
    ? 'готов'
    : status === 'waiting_on_counter'
    ? 'на стойке корнера'
    : status === 'issued_courier'
    ? 'у раннера'
    : status === 'received'
    ? 'выдан'
    : ''

export const translateToStyleOrder = (status: OrderStatus) =>
  status === 'waiting'
    ? 'не принят'
    : status === 'confirmed'
    ? 'принят'
    : status === 'refused'
    ? 'отклонён'
    : status === 'expects'
    ? 'в процессе'
    : status === 'cooking'
    ? 'в процессе'
    : status === 'ready'
    ? 'готов'
    : status === 'issued_courier'
    ? 'у раннера'
    : status === 'waiting_on_counter'
    ? 'ожидает клиента'
    : status === 'received'
    ? 'заказ выдан клиенту'
    : ''

export const decodeAndGet = <T>(schema: ZodSchema<T>, payload: unknown): [T | undefined, string] => {
  const result = schema.safeParse(payload)
  if (result.success) return [result.data, '']
  return [undefined, result.error.message]
}

export const playSound = (audioFile: { play: () => any }) => {
  return audioFile.play()
}

export const translateEnabledToStatus = (enabled: boolean | undefined) => (enabled ? 'Работаем' : 'Общий стоп')
